import { Tag } from "antd";
import moment from "moment";

const statusColor = {
  success: "green",
  failed: "red",
  pending: "gold",
};

const messageTypeLabel = {
  OTA_HotelAvailNotifRQ: "Availability",
  OTA_HotelAvailNotifRQ_Restriction: "Restrictions",
  OTA_HotelRateAmountNotifRQ: "Rates",
  OTA_HotelResNotifRQ: "Reservation (inbound)",
};

export const getSyncLogColumns = () => {
  return [
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value) => moment(value).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Type",
      dataIndex: "messageType",
      key: "messageType",
      render: (value) => messageTypeLabel[value] || value,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={statusColor[status] || "default"}>{status}</Tag>,
    },
    {
      title: "Attempts",
      dataIndex: "attempts",
      key: "attempts",
    },
    {
      title: "Error",
      dataIndex: "lastError",
      key: "lastError",
      render: (value) => value || "—",
    },
  ];
};
